var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIkonaKalendarz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.74 4.9H1.26V2.52H3.5v.84a.14.14 0 00.14.139h.98a.14.14 0 00.14-.139v-.84h4.48v.84a.14.14 0 00.14.139h.981a.14.14 0 00.139-.139v-.84h2.24zm0 7.841H1.26V6.09h11.48zm.7-11.481H10.5V.14a.141.141 0 00-.139-.14H9.38a.141.141 0 00-.14.14v1.12H4.76V.14A.14.14 0 004.62 0h-.98a.141.141 0 00-.14.14v1.12H.56a.56.56 0 00-.56.561v11.62A.559.559 0 00.56 14h12.88a.559.559 0 00.56-.559V1.82a.56.56 0 00-.56-.56z",
    fill: "#750b22"
  })));
}

export default SvgIkonaKalendarz;